var perflibLoader;

module.exports = perflibLoader = function() {
  var externalObjectLoader, found, frame, frameId, frames, i, len, onloadScript, ref, url, w;
  onloadScript = function() {
    var defaultConfig, key, timer, w;
    w = window;
    if (w !== w.parent) {
      w = window.parent;
      window.BOOMR = w.BOOMR;
      window.Groupon = w.Groupon;
      window.OptimizeSuite = w.OptimizeSuite;
      window.applicationConfig = w.applicationConfig;
    }
    defaultConfig = {
      user_ip: BOOMR.utils.getCookie('b'),
      beacon_url: "/analytic/view.gif",
      BW: {
        enabled: false
      },
      DNS: {
        enabled: false
      },
      autorun: false
    };
    if (typeof applicationConfig !== "undefined" && applicationConfig !== null) {
      for (key in applicationConfig) {
        if (applicationConfig[key] != null) {
          defaultConfig[key] = applicationConfig[key];
        }
      }
    }
    BOOMR.init(defaultConfig);
    if (BOOMR.t_lstart != null) {
      BOOMR.addVar("t_lstart", BOOMR.t_lstart);
    }
    for (timer in BOOMR.gtimers) {
      BOOMR.addVar(timer, BOOMR.gtimers[timer]);
    }
    BOOMR.subscribe('before_beacon', function(performance) {
      var pageData, ref, ref1, ref2, ref3, ref4, ref5;
      if ((BOOMR.t_header != null) && (((ref = window.performance) != null ? (ref1 = ref.timing) != null ? ref1.requestStart : void 0 : void 0) != null)) {
        BOOMR.addVar('t_header', BOOMR.t_header - window.performance.timing.requestStart);
      }
      if (OptimizeSuite.TrackingHub.page != null) {
        pageData = OptimizeSuite.TrackingHub.page.data();
        BOOMR.addVar("page_channel", (ref2 = pageData.channel) != null ? ref2 : "");
        BOOMR.addVar("page_country", (ref3 = pageData.country) != null ? ref3 : "");
        BOOMR.addVar("page_division", (ref4 = pageData.division) != null ? ref4 : "");
        BOOMR.addVar("page_type", (ref5 = pageData.type) != null ? ref5 : "");
      }
      return OptimizeSuite.TrackingHub.add("performance", {
        performance: performance
      });
    });
    BOOMR.t_end = new Date().getTime();
    BOOMR.addVar("t_end", BOOMR.t_end);
    if (BOOMR.t_done != null) {
      BOOMR.plugins.RT.endTimer("t_done", BOOMR.t_done);
      return BOOMR.page_ready();
    }
  };
  externalObjectLoader = function(url, onloadScript, id) {
    var doc, dom, error, iframe, where;
    if (id == null) {
      id = 'js-iframe-async';
    }
    iframe = document.createElement('iframe');
    iframe.src = "javascript:false";
    iframe.setAttribute('aria-hidden', 'true');
    iframe.hidden = "hidden";
    (iframe.frameElement || iframe).style.cssText = 'width: 0; height: 0; border: 0; position: absolute';
    iframe.frameBorder = 0;
    where = document.getElementsByTagName('script');
    where = where[where.length - 1];
    where.parentNode.insertBefore(iframe, where);
    try {
      doc = iframe.contentWindow.document;
    } catch (error1) {
      error = error1;
      dom = document.domain;
      iframe.src = "javascript: var d = document.open();d.domain='" + dom + "';void(0);";
      doc = iframe.contentWindow.document;
    }
    doc.open()._load3po = function() {
      var js, scriptInit;
      if (dom != null) {
        this.domain = dom;
      }
      scriptInit = this.createElement("script");
      scriptInit.type = "text/javascript";
      scriptInit.text = "Groupon = window.parent.Groupon;$ = window.parent.$";
      this.body.appendChild(scriptInit);
      js = this.createElement("script");
      js.type = "text/javascript";
      js.id = id;
      js.src = url;
      if (onloadScript != null) {
        js.onload = onloadScript;
      }
      return this.body.appendChild(js);
    };
    doc.write('<body onload="document._load3po();">');
    return doc.close();
  };
  w = window;
  if (w !== w.parent) {
    w = window.parent;
  }
  frames = w.frames;
  found = false;
  frameId = 'boomr-if-as';
  for (i = 0, len = frames.length; i < len; i++) {
    frame = frames[i];
    try {
      if ((frame != null ? frame.frames['boomr-if-as'] : void 0) != null) {
        found = true;
        break;
      }
    } catch (error1) {

    }
  }
  url = (typeof Groupon !== "undefined" && Groupon !== null ? (ref = Groupon.Performance) != null ? ref.boomerangUrl : void 0 : void 0) || '/layout/assets/boomerang-basic-custom-0_9_3.js';
  if (!found) {
    return externalObjectLoader(url, onloadScript, frameId);
  }
};

//# sourceMappingURL=data:application/json;base64,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
